var perflibLoader;

module.exports = perflibLoader = function() {
  var externalObjectLoader, found, frame, frameId, frames, i, len, onloadScript, ref, url, w;
  onloadScript = function() {
    var defaultConfig, key, timer, w;
    w = window;
    if (w !== w.parent) {
      w = window.parent;
      window.BOOMR = w.BOOMR;
      window.Groupon = w.Groupon;
      window.OptimizeSuite = w.OptimizeSuite;
      window.applicationConfig = w.applicationConfig;
    }
    defaultConfig = {
      user_ip: BOOMR.utils.getCookie('b'),
      beacon_url: "/analytic/view.gif",
      BW: {
        enabled: false
      },
      DNS: {
        enabled: false
      },
      autorun: false
    };
    if (typeof applicationConfig !== "undefined" && applicationConfig !== null) {
      for (key in applicationConfig) {
        if (applicationConfig[key] != null) {
          defaultConfig[key] = applicationConfig[key];
        }
      }
    }
    BOOMR.init(defaultConfig);
    if (BOOMR.t_lstart != null) {
      BOOMR.addVar("t_lstart", BOOMR.t_lstart);
    }
    for (timer in BOOMR.gtimers) {
      BOOMR.addVar(timer, BOOMR.gtimers[timer]);
    }
    BOOMR.subscribe('before_beacon', function(performance) {
      var pageData, ref, ref1, ref2, ref3, ref4, ref5;
      if ((BOOMR.t_header != null) && (((ref = window.performance) != null ? (ref1 = ref.timing) != null ? ref1.requestStart : void 0 : void 0) != null)) {
        BOOMR.addVar('t_header', BOOMR.t_header - window.performance.timing.requestStart);
      }
      if (OptimizeSuite.TrackingHub.page != null) {
        pageData = OptimizeSuite.TrackingHub.page.data();
        BOOMR.addVar("page_channel", (ref2 = pageData.channel) != null ? ref2 : "");
        BOOMR.addVar("page_country", (ref3 = pageData.country) != null ? ref3 : "");
        BOOMR.addVar("page_division", (ref4 = pageData.division) != null ? ref4 : "");
        BOOMR.addVar("page_type", (ref5 = pageData.type) != null ? ref5 : "");
      }
      return OptimizeSuite.TrackingHub.add("performance", {
        performance: performance
      });
    });
    BOOMR.t_end = new Date().getTime();
    BOOMR.addVar("t_end", BOOMR.t_end);
    if (BOOMR.t_done != null) {
      BOOMR.plugins.RT.endTimer("t_done", BOOMR.t_done);
      return BOOMR.page_ready();
    }
  };
  externalObjectLoader = function(url, onloadScript, id) {
    var doc, dom, error, iframe, where;
    if (id == null) {
      id = 'js-iframe-async';
    }
    iframe = document.createElement('iframe');
    iframe.src = "javascript:false";
    iframe.setAttribute('aria-hidden', 'true');
    iframe.hidden = "hidden";
    (iframe.frameElement || iframe).style.cssText = 'width: 0; height: 0; border: 0; position: absolute';
    iframe.frameBorder = 0;
    where = document.getElementsByTagName('script');
    where = where[where.length - 1];
    where.parentNode.insertBefore(iframe, where);
    try {
      doc = iframe.contentWindow.document;
    } catch (error1) {
      error = error1;
      dom = document.domain;
      iframe.src = "javascript: var d = document.open();d.domain='" + dom + "';void(0);";
      doc = iframe.contentWindow.document;
    }
    doc.open()._load3po = function() {
      var js, scriptInit;
      if (dom != null) {
        this.domain = dom;
      }
      scriptInit = this.createElement("script");
      scriptInit.type = "text/javascript";
      scriptInit.text = "Groupon = window.parent.Groupon;$ = window.parent.$";
      this.body.appendChild(scriptInit);
      js = this.createElement("script");
      js.type = "text/javascript";
      js.id = id;
      js.src = url;
      if (onloadScript != null) {
        js.onload = onloadScript;
      }
      return this.body.appendChild(js);
    };
    doc.write('<body onload="document._load3po();">');
    return doc.close();
  };
  w = window;
  if (w !== w.parent) {
    w = window.parent;
  }
  frames = w.frames;
  found = false;
  frameId = 'boomr-if-as';
  for (i = 0, len = frames.length; i < len; i++) {
    frame = frames[i];
    try {
      if ((frame != null ? frame.frames['boomr-if-as'] : void 0) != null) {
        found = true;
        break;
      }
    } catch (error1) {

    }
  }
  url = (typeof Groupon !== "undefined" && Groupon !== null ? (ref = Groupon.Performance) != null ? ref.boomerangUrl : void 0 : void 0) || '/layout/assets/boomerang-basic-custom-0_9_3.js';
  if (!found) {
    return externalObjectLoader(url, onloadScript, frameId);
  }
};

//# sourceMappingURL=data:application/json;base64,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
